var perflibLoader;

module.exports = perflibLoader = function() {
  var externalObjectLoader, found, frame, frameId, frames, i, len, onloadScript, ref, url, w;
  onloadScript = function() {
    var defaultConfig, key, timer, w;
    w = window;
    if (w !== w.parent) {
      w = window.parent;
      window.BOOMR = w.BOOMR;
      window.Groupon = w.Groupon;
      window.OptimizeSuite = w.OptimizeSuite;
      window.applicationConfig = w.applicationConfig;
    }
    defaultConfig = {
      user_ip: BOOMR.utils.getCookie('b'),
      beacon_url: "/analytic/view.gif",
      BW: {
        enabled: false
      },
      DNS: {
        enabled: false
      },
      autorun: false
    };
    if (typeof applicationConfig !== "undefined" && applicationConfig !== null) {
      for (key in applicationConfig) {
        if (applicationConfig[key] != null) {
          defaultConfig[key] = applicationConfig[key];
        }
      }
    }
    BOOMR.init(defaultConfig);
    if (BOOMR.t_lstart != null) {
      BOOMR.addVar("t_lstart", BOOMR.t_lstart);
    }
    for (timer in BOOMR.gtimers) {
      BOOMR.addVar(timer, BOOMR.gtimers[timer]);
    }
    BOOMR.subscribe('before_beacon', function(performance) {
      var pageData, ref, ref1, ref2, ref3, ref4, ref5;
      if ((BOOMR.t_header != null) && (((ref = window.performance) != null ? (ref1 = ref.timing) != null ? ref1.requestStart : void 0 : void 0) != null)) {
        BOOMR.addVar('t_header', BOOMR.t_header - window.performance.timing.requestStart);
      }
      if (OptimizeSuite.TrackingHub.page != null) {
        pageData = OptimizeSuite.TrackingHub.page.data();
        BOOMR.addVar("page_channel", (ref2 = pageData.channel) != null ? ref2 : "");
        BOOMR.addVar("page_country", (ref3 = pageData.country) != null ? ref3 : "");
        BOOMR.addVar("page_division", (ref4 = pageData.division) != null ? ref4 : "");
        BOOMR.addVar("page_type", (ref5 = pageData.type) != null ? ref5 : "");
      }
      return OptimizeSuite.TrackingHub.add("performance", {
        performance: performance
      });
    });
    BOOMR.t_end = new Date().getTime();
    BOOMR.addVar("t_end", BOOMR.t_end);
    if (BOOMR.t_done != null) {
      BOOMR.plugins.RT.endTimer("t_done", BOOMR.t_done);
      return BOOMR.page_ready();
    }
  };
  externalObjectLoader = function(url, onloadScript, id) {
    var doc, dom, error, iframe, where;
    if (id == null) {
      id = 'js-iframe-async';
    }
    iframe = document.createElement('iframe');
    iframe.src = "javascript:false";
    iframe.setAttribute('aria-hidden', 'true');
    iframe.hidden = "hidden";
    (iframe.frameElement || iframe).style.cssText = 'width: 0; height: 0; border: 0; position: absolute';
    iframe.frameBorder = 0;
    where = document.getElementsByTagName('script');
    where = where[where.length - 1];
    where.parentNode.insertBefore(iframe, where);
    try {
      doc = iframe.contentWindow.document;
    } catch (error1) {
      error = error1;
      dom = document.domain;
      iframe.src = "javascript: var d = document.open();d.domain='" + dom + "';void(0);";
      doc = iframe.contentWindow.document;
    }
    doc.open()._load3po = function() {
      var js, scriptInit;
      if (dom != null) {
        this.domain = dom;
      }
      scriptInit = this.createElement("script");
      scriptInit.type = "text/javascript";
      scriptInit.text = "Groupon = window.parent.Groupon;$ = window.parent.$";
      this.body.appendChild(scriptInit);
      js = this.createElement("script");
      js.type = "text/javascript";
      js.id = id;
      js.src = url;
      if (onloadScript != null) {
        js.onload = onloadScript;
      }
      return this.body.appendChild(js);
    };
    doc.write('<body onload="document._load3po();">');
    return doc.close();
  };
  w = window;
  if (w !== w.parent) {
    w = window.parent;
  }
  frames = w.frames;
  found = false;
  frameId = 'boomr-if-as';
  for (i = 0, len = frames.length; i < len; i++) {
    frame = frames[i];
    try {
      if ((frame != null ? frame.frames['boomr-if-as'] : void 0) != null) {
        found = true;
        break;
      }
    } catch (error1) {

    }
  }
  url = (typeof Groupon !== "undefined" && Groupon !== null ? (ref = Groupon.Performance) != null ? ref.boomerangUrl : void 0 : void 0) || '/layout/assets/boomerang-basic-custom-0_9_3.js';
  if (!found) {
    return externalObjectLoader(url, onloadScript, frameId);
  }
};

//# sourceMappingURL=data:application/json;base64,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
